import React from "react";

import classes from "./Count.module.scss";
import Section from "../Section/Section";

const Count = (props) => {
  return (
    <Section>
      <div className={classes.label}>{props.children}</div>
      <div className={classes.count}>{props.count}</div>
    </Section>
  );
};

export default Count;
